<template>
  <div :id="containerId" style="position: relative">

    <!--  ---------------------------- begin 图片左右换位置 ------------------------------------- -->
    <div class="movety-container" :style="{top:top+'px',left:left+'px',display:moveDisplay}" style="padding:0 8px;position: absolute;z-index: 91;height: 32px;width: 104px;text-align: center;">
      <div :id="containerId+'-mover'" :class="showMoverTask?'uploadty-mover-mask':'movety-opt'" style="margin-top: 12px">
        <a @click="moveLast" style="margin: 0 5px;"><a-icon type="arrow-left" style="color: #fff;font-size: 16px"/></a>
        <a @click="moveNext" style="margin: 0 5px;"><a-icon type="arrow-right" style="color: #fff;font-size: 16px"/></a>
      </div>
    </div>
    <!--  ---------------------------- end 图片左右换位置 ------------------------------------- -->

    <a-upload
      name="file"
      :multiple="true"
      :action="uploadAction"
      :headers="headers"
      :data="{'biz':bizPath}"
      :fileList="fileList"
      :beforeUpload="beforeUpload"
      @change="handleChange"
      :disabled="disabled"
      :returnUrl="returnUrl"
      :listType="complistType"
      @preview="handlePreview"
      :class="{'uploadty-disabled':disabled}">
      <template>

        <div v-if="isImageComp">
          <a-icon type="plus" />
          <div class="ant-upload-text">{{ text }}</div>
        </div>
        <a-button v-else-if="buttonVisible">
          <a-icon type="upload" />{{ text }}
        </a-button>

        <a-button v-else-if="buttonLs">
          <a-button style="width: 133px;"  type="primary">{{ text }}</a-button>
        </a-button>

      </template>
    </a-upload>
    <a-modal :visible="previewVisible"  :wrapClassName="'ant-modal-wrap'+tranfrom"  :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage"  @click="toTranfrom"/>
    </a-modal>
    <a-modal :visible="videoVisible"  :footer="null" @cancel="handleCancel">
      <video width="100%" id="video" controls>
        <source :src="previewImage" type="video/mp4">
        <source :src="previewImage" type="video/ogg">
        <source :src="previewImage" type="video/webm">
        <object :data="previewImage" width="100%">
          <embed :src="previewImage" width="100%">
        </object>
      </video>
    </a-modal>
  </div>
</template>

<script>

  import Vue from 'vue'
  import { ACCESS_TOKEN } from "@/store/mutation-types"
  import { getFileAccessHttpUrl } from '@/api/manage';
import { getAccessToken } from '@/utils/token'

  const FILE_TYPE_ALL = "all"
  const FILE_TYPE_IMG = "image"
  const FILE_TYPE_VIDEO = "mp4,av"
  const FILE_TYPE_TXT = "file"
  const uidGenerator=()=>{
    return '-'+parseInt(Math.random()*10000+1,10);
  }
  const getFileName=(path)=>{
    if(path.lastIndexOf("\\")>=0){
      let reg=new RegExp("\\\\","g");
      path = path.replace(reg,"/");
    }
    return path.substring(path.lastIndexOf("/")+1);
  }
  export default {
    name: 'JUpload',
    data(){
      return {
        uploadAction:window._CONFIG['domianURL']+"/sys/common/upload",
        headers:{},
        fileList: [],
        newFileList: [],
        uploadGoOn:true,
        previewVisible: false,
        videoVisible:false,
        //---------------------------- begin 图片左右换位置 -------------------------------------
        previewImage: '',
        containerId:'',
        top:'',
        left:'',
        moveDisplay:'none',
        showMoverTask:false,
        moverHold:false,
        currentImg:'',
        filetype:'',
        picUrl:false,
        uploadLoading:false,

        tranfrom:1
        //---------------------------- end 图片左右换位置 -------------------------------------
      }
    },
    props:{
      text:{
        type:String,
        required:false,
        default:"点击上传"
      },
      fileType:{
        type:String,
        required:false,
        default:FILE_TYPE_ALL
      },
      /*这个属性用于控制文件上传的业务路径*/
      bizPath:{
        type:String,
        required:false,
        default:"temp"
      },
      value:{
        type:[String,Array],
        required:false
      },
      // update-begin- --- author:wangshuai ------ date:20190929 ---- for:Jupload组件增加是否能够点击
      disabled:{
        type:Boolean,
        required:false,
        default: false
      },
      // update-end- --- author:wangshuai ------ date:20190929 ---- for:Jupload组件增加是否能够点击
      //此属性被废弃了
      triggerChange:{
        type: Boolean,
        required: false,
        default: false
      },
      /**
       * update -- author:lvdandan -- date:20190219 -- for:Jupload组件增加是否返回url，
       * true：仅返回url
       * false：返回fileName filePath fileSize
       */
      returnUrl:{
        type:Boolean,
        required:false,
        default: true
      },
      number:{
        type:Number,
        required:false,
        default: 0
      },
      buttonVisible:{
        type:Boolean,
        required:false,
        default: true
      },buttonLs:{
        type:Boolean,
        required:false,
        default: false
      },
      isVideo:{
        type:Boolean,
        required:false,
        default: false
      },
      width:{
        type:Number,
        required:false,
        default:104
      },
      height:{
        type:Number,
        required:false,
        default:104
      },
      fmUrl:{
        type:[String,Array],
        required:false
      }
    },
    watch:{
      value:{
        immediate: true,
        handler() {
          let val = this.value
          if (val instanceof Array) {
            if(this.returnUrl){
              this.initFileList(val.join(','))
            }else{
              this.initFileListArr(val);
            }
          } else {
            this.initFileList(val)
          }
          if(!val || val.length==0){
            this.picUrl = false;
          }
        }
      }
    },
    computed:{
      isImageComp(){
        return this.fileType === FILE_TYPE_IMG
      },
      complistType(){
        return this.fileType === FILE_TYPE_IMG?'picture-card':'text'
      }
    },
    created(){
      const token = getAccessToken();
      //---------------------------- begin 图片左右换位置 -------------------------------------
      this.headers = {"X-Access-Token":token};
      this.containerId = 'container-ty-'+new Date().getTime();
      //---------------------------- end 图片左右换位置 -------------------------------------
    },

    methods:{
      initFileListArr(val){
        if(!val || val.length==0){
          this.fileList = [];
          return;
        }
        let fileList = [];
        this.picUrl = true;
        for(var a=0;a<val.length;a++){
          let url = getFileAccessHttpUrl(val[a].filePath);
          fileList.push({
            uid:uidGenerator(),
            name:val[a].fileName,
            status: 'done',
            url: url,
            response:{
              status:"history",
              message:val[a].filePath
            }
          })
        }
        this.fileList = fileList
      },
      initFileList(paths){
        if(!paths || paths.length==0){
          //return [];
          // update-begin- --- author:os_chengtgen ------ date:20190729 ---- for:issues:326,Jupload组件初始化bug
          this.fileList = [];
          return;
          // update-end- --- author:os_chengtgen ------ date:20190729 ---- for:issues:326,Jupload组件初始化bug
        }
        let fileList = [];
        let arr = paths.split(",")
        for(var a=0;a<arr.length;a++){
          let url = getFileAccessHttpUrl(arr[a]);
          fileList.push({
            uid:uidGenerator(),
            name:getFileName(arr[a]),
            status: 'done',
            url: url,
            response:{
              status:"history",
              message:arr[a]
            }
          })
        }
        this.fileList = fileList
      },
      getAvatarView(){
        if(this.fileList.length>0){
          let url = this.fileList[0].url
          return getFileAccessHttpUrl(url)
        }
      },
      handlePathChange(){
        let uploadFiles = this.fileList
        let path = ''
        if(!uploadFiles || uploadFiles.length==0){
          path = ''
        }
        let arr = [];

        for(var a=0;a<uploadFiles.length;a++){
          // update-begin-author:lvdandan date:20200603 for:【TESTA-514】【开源issue】多个文件同时上传时，控制台报错
          if(uploadFiles[a].status === 'done' ) {
            arr.push(uploadFiles[a].response.message)
          }else{
            return;
          }
          // update-end-author:lvdandan date:20200603 for:【TESTA-514】【开源issue】多个文件同时上传时，控制台报错
        }
        if(arr.length>0){
          path = arr.join(",")
        }
        this.$emit('change', path);
      },
      beforeUpload(file){
        this.uploadGoOn=true
        var fileType = file.type;
        if(this.fileType===FILE_TYPE_IMG){
          if(fileType.indexOf('image')<0){
            this.$message.warning('请上传图片');
            this.uploadGoOn=false
            return false;
          }
        }else if(this.fileType==='mp4'){
          if(fileType.indexOf('mp4')<0){
            this.$message.warning('请上传MP4格式文件');
            this.uploadGoOn=false
            return false;
          }
        }
        this.filetype = fileType;
        //如果上传的是视频 计算视频时长
        if(this.isVideo){
          //this.getTimes(file);
        }
        //TODO 扩展功能验证文件大小
        return true
      },getTimes(file) {  //获取时长
        var content = file;
        var url = URL.createObjectURL(content);
        //经测试，发现audio也可获取视频的时长
        var audioElement = new Audio(url);
          audioElement.addEventListener("loadedmetadata", (_event) => {
          let audioDuration = parseInt(audioElement.duration);
          //这个时候计算出来的时长是秒
          //将时长格式化为 xx：xx的格式
           let mintue = parseInt(audioDuration/60);
           if(mintue<10){
             mintue = "0"+mintue;
           }
           let second = audioDuration%60;
           if(second<10){
             second = "0"+second;
           }
           this.$emit("setDuration",mintue+":"+second);
        });
      },deletePic(){
        let file = this.fileList[0]
        file.status = 'removed';
        let info ={
          file:file
        }
        this.handleChange(info);
      },toTranfrom(){
        if(this.tranfrom>=4){
          this.tranfrom = 1;
        }else{
          this.tranfrom++;
        }
      },
      handleChange(info) {

        if(!info.file.status && this.uploadGoOn === false){
          info.fileList.pop();
        }
        let fileList = info.fileList
        this.picUrl = false;
        if(info.file.status==='done'){
          if(this.number>0){
            fileList = fileList.slice(-this.number);
          }
          if(info.file.response.success){
            this.picUrl = true;
            fileList = fileList.map((file) => {
              if (file.response) {
                let reUrl = file.response.message;
                file.url = getFileAccessHttpUrl(reUrl);
                let map  = file.response.result;

                if(map&&map.fm_url){
                  file.fmUrl = map.fm_url;
                }
              }
              return file;
            });
          }
          //this.$message.success(`${info.file.name} 上传成功!`);
        }else if (info.file.status === 'error') {
          this.$message.error(`${info.file.name} 上传失败.`);
        }else if(info.file.status === 'removed'){
          this.handleDelete(info.file)
        }
        this.fileList = fileList
        if(fileList && fileList.length>0){
          //returnUrl为true时仅返回文件路径
          if(this.returnUrl){
            this.handlePathChange()
          }else{
            //returnUrl为false时返回文件名称、文件路径及文件大小
            this.newFileList = [];
            for(var a=0;a<fileList.length;a++){
              // update-begin-author:lvdandan date:20200603 for:【TESTA-514】【开源issue】多个文件同时上传时，控制台报错
              if(fileList[a].status === 'done' ) {
                var fileJson = {
                  fileName:fileList[a].name,
                  filePath:fileList[a].response.message,
                  fileSize:fileList[a].size
                };
                this.newFileList.push(fileJson);
              }else{
                return;
              }
              // update-end-author:lvdandan date:20200603 for:【TESTA-514】【开源issue】多个文件同时上传时，控制台报错
            }
            this.$emit('change', this.newFileList);
          }
        }
      },
      handleDelete(file){
        //如有需要新增 删除逻辑
        console.log(file)
      },
      handlePreview(file){
        let fileType = 'image';
        if(file.url.indexOf(".png")==-1 && file.url.indexOf(".jpg")==-1 && file.url.indexOf(".jpeg")==-1 && file.url.indexOf(".gif")==-1&& file.url.indexOf(".bmp")==-1){
          fileType = "video";
        }
        this.previewImage = file.url || file.thumbUrl;
        if(fileType === FILE_TYPE_IMG){
          this.previewVisible = true;
        }else if(FILE_TYPE_VIDEO.indexOf(fileType)!==-1){
          //location.href=file.url
         // window.open(file.url);
          this.videoVisible = true;
        }else{
          window.open(file.url);
        }
      },
      handleCancel(){
        this.previewVisible = false;
        this.videoVisible = false;
      },
      // 预览
      handlePreviewBtn () {
        let file = this.fileList[0]
        this.previewImage = file.url || file.thumbUrl
        this.previewVisible = true
      },
      //---------------------------- begin 图片左右换位置 -------------------------------------
      moveLast(){
        //console.log(ev)
        //console.log(this.fileList)
        //console.log(this.currentImg)
        let index = this.getIndexByUrl();
        if(index==0){
          this.$message.warn('未知的操作')
        }else{

          let curr = this.fileList[index].url;
          let last = this.fileList[index-1].url;
          let arr =[]
          let fmArr = []
          for(let i=0;i<this.fileList.length;i++){
            if(i==index-1){
              arr.push(curr)
              fmArr.push(this.fileList[index].fmUrl)
            }else if(i==index){
              arr.push(last)
              fmArr.push(this.fileList[index-1].fmUrl)
            }else{
              arr.push(this.fileList[i].url)
              fmArr.push(this.fileList[i].fmUrl)
            }
          }
          this.currentImg = last
          this.$emit('change',arr.join(','),fmArr.join(","))
        }
      },
      moveNext(){
        let index = this.getIndexByUrl();
        if(index==this.fileList.length-1){
          this.$message.warn('已到最后~')
        }else{
          let curr = this.fileList[index].url;
          let next = this.fileList[index+1].url;
          let arr =[]
          let fmArr = []
          for(let i=0;i<this.fileList.length;i++){
            if(i==index+1){
              arr.push(curr)
              fmArr.push(this.fileList[index].fmUrl)
            }else if(i==index){
              arr.push(next)
              fmArr.push(this.fileList[index+1].fmUrl)
            }else{
              arr.push(this.fileList[i].url)
              fmArr.push(this.fileList[i].fmUrl)
            }
          }
          this.currentImg = next
          console.log(this.fileList)
          this.$emit('change',arr.join(','),fmArr.join(","))
        }
      },
      getIndexByUrl(){
        for(let i=0;i<this.fileList.length;i++){
          if(this.fileList[i].url === this.currentImg || encodeURI(this.fileList[i].url) === this.currentImg){
            return i;
          }
        }
        return -1;
      }
    },
    mounted(){
      const moverObj = document.getElementById(this.containerId+'-mover');
      if(moverObj){
        moverObj.addEventListener('mouseover',()=>{
          this.moverHold = true
          this.moveDisplay = 'block';
        });
        moverObj.addEventListener('mouseout',()=>{
          this.moverHold = false
          this.moveDisplay = 'none';
        });
      }

      let picList = document.getElementById(this.containerId)?document.getElementById(this.containerId).getElementsByClassName('ant-upload-list-picture-card'):[];
      if(picList && picList.length>0){
        picList[0].addEventListener('mouseover',(ev)=>{
          ev = ev || window.event;
          let target = ev.target || ev.srcElement;
          if('ant-upload-list-item-info' == target.className){
            this.showMoverTask=false
            let item = target.parentElement
            this.left = item.offsetLeft
            this.top=item.offsetTop+item.offsetHeight-50;
            this.moveDisplay = 'block';
            this.currentImg = target.getElementsByTagName('img')[0].src
          }

        });

        picList[0].addEventListener('mouseout',(ev)=>{
          ev = ev || window.event;
          let target = ev.target || ev.srcElement;
          //console.log('移除',target)
          if('ant-upload-list-item-info' == target.className){
            this.showMoverTask=true
            setTimeout(()=>{
              if(this.moverHold === false)
                this.moveDisplay = 'none';
            },100)
          }
          if('ant-upload-list-item ant-upload-list-item-done' == target.className || 'ant-upload-list ant-upload-list-picture-card'== target.className){
            this.moveDisplay = 'none';
          }
        })
        //---------------------------- end 图片左右换位置 -------------------------------------
      }
    },
    model: {
      prop: 'value',
      event: 'change'
    }
  }
</script>

<style lang="less">
.uploadty-disabled{
  .ant-upload-list-item {
    .anticon-close{
      display: none;
    }
    .anticon-delete{
      display: none;
    }
  }
}
  //---------------------------- begin 图片左右换位置 -------------------------------------
  .uploadty-mover-mask{
    background-color: rgba(0, 0, 0, 0.5);
    opacity: .8;
    color: #fff;
    height: 28px;
    line-height: 28px;
  }

.ant-modal-wrap1{
  left: -30%;
}
.ant-modal-wrap2{
  left: -30%;
  transform: rotate(90deg);
}
.ant-modal-wrap3{
  left: -30%;
  transform: rotate(180deg);
}
.ant-modal-wrap4{
  left: -30%;
  transform: rotate(270deg);
}
  //---------------------------- end 图片左右换位置 -------------------------------------
</style>
